// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// CC-Common imports
import { CCDeviceService } from '@therealmanage/ciranet-ui-common';
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

// Service imports
import { AuthService } from '../auth.service';
import { UserService } from '../data-services/user.service';
import { ScreenService } from './screen.service';

// Model imports
import { UserActivity } from '../../_models/user-activity';

// Service imports
import { EnvironmentConfigService } from '../environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class UserBackgroundService {
  constructor(
    private http: HttpClient,
    private screenService: ScreenService,
    private deviceService: CCDeviceService,
    private authService: AuthService,
    private userService: UserService,
    private envConfig: EnvironmentConfigService
  ) {}

  logActivity(
    route: string,
    action: string,
    time: Date,
    info?: string,
    communityId?: number
  ) {
    if (this.authService.isLoggedIn == true) {
      const userActivity = new UserActivity();
      userActivity.host = this.envConfig.identityApiUrl;

      // UserId and Alias
      if (this.userService.isImpersonated()) {
        userActivity.userId = this.userService.impersonatingUserId();

        if (!!this.authService.decodedToken) {
          userActivity.alias = this.userService.impersonatedUserId();
        }
      } else {
        if (!!this.authService.decodedToken) {
          userActivity.userId = this.authService.decodedToken.nameid;
          userActivity.alias = this.authService.decodedToken.nameid;
        }
      }

      if (!!userActivity.userId) {
        if (!communityId) {
          const selectedProperty = this.userService.getSelectedProperty();
          communityId = !!selectedProperty
            ? selectedProperty.communityId
            : communityId;
        }

        userActivity.route = route;
        userActivity.activity = action;
        userActivity.additionalInfo = info;
        userActivity.dateTimeStamp = time;
        userActivity.communityId = communityId ? communityId : -1;

        // Client IP
        userActivity.clientIP = null;

        // ServerName
        userActivity.serverName = null;

        // Screen
        userActivity.screenSize = this.screenService.getCurrentScreenSize;

        // Device
        const deviceInfo = this.deviceService.deviceInfomation;

        if (deviceInfo !== undefined) {
          userActivity.browser = deviceInfo.browser;
          userActivity.browserVersion = deviceInfo.browser_version;
          userActivity.operatingSystem = deviceInfo.os;
          userActivity.osVersion = deviceInfo.os_version;
          userActivity.device = deviceInfo.device;
          userActivity.userAgent = deviceInfo.userAgent;
        }

        RxjsUtils.safeSubscribe(
          this.http.post(
            this.envConfig.identityApiUrl + 'user/activity',
            userActivity
          ),
          () => {}
        );
      }
    }
  }
}
